import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import get from 'lodash.get';
import tracking from 'dibs-tracking';

import { FormattedMessage } from 'react-intl';
import { Button } from 'dibs-elements/exports/Button';
import singleItemHoldRequestLauncher from 'dibs-buyer-layout/exports/singleItemHoldRequestLauncher';

export class PdpSharedRequestHold extends Component {
    constructor() {
        super();
        this.requestHold = this.requestHold.bind(this);
    }
    requestHold() {
        const {
            relay: { environment },
            itemId,
            userId,
            trackingLocation,
        } = this.props;
        tracking.trackEvent({
            action: 'contact dealer clicked',
            category: 'contact dealer',
            label: `request a hold - ${trackingLocation}`,
        });
        singleItemHoldRequestLauncher({
            environment,
            itemId,
            userId,
            linkLocation: trackingLocation,
        });
    }
    render() {
        const { hasRequestedHoldForBuyer, displayInfo } = this.props.item || {};

        if (hasRequestedHoldForBuyer) {
            return (
                <Button type="secondary" dataTn="pdp-shared-hold-requested" size="small" disabled>
                    <FormattedMessage
                        id="PdpRespSidebarContact.holdRequested"
                        defaultMessage="Hold requested"
                    />
                </Button>
            );
        }

        if (get(displayInfo, 'ctas.showHoldRequest')) {
            return (
                <Button
                    type="secondary"
                    dataTn="pdp-shared-request-hold"
                    size="small"
                    disabled={hasRequestedHoldForBuyer}
                    onClick={this.requestHold}
                >
                    <FormattedMessage
                        id="PdpRespSidebarContact.requestHold"
                        defaultMessage="Request a Hold"
                    />
                </Button>
            );
        }

        return null;
    }
}

PdpSharedRequestHold.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object,
    user: PropTypes.object,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    trackingLocation: PropTypes.string,
};

export default createFragmentContainer(PdpSharedRequestHold, {
    item: graphql`
        fragment PdpSharedRequestHold_item on Item {
            hasRequestedHoldForBuyer(buyerId: $userId) @include(if: $isClient)
            displayInfo(page: pdp, buyerId: $userId) @include(if: $isClient) {
                ctas {
                    showHoldRequest
                }
            }
        }
    `,
});
